// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.send-attachment-modal {
  border-radius: 5px;
  background-color: white;
  position: relative;
  height: 400px;
  width: 300px;
  padding: 3%;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

.send-attachment-modal-preview {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(96, 125, 139, 0.2);
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.02);
  overflow: hidden;
}

.send-attachment-modal-image {
  max-width: 100%;
  max-height: 90%;
  object-fit: contain;
}

.send-attachment-modal-image.thumbnail {
  /* Actual thumbnail from generated image/video */
  border-radius: 3px;
}

.send-attachment-modal-image.file-icon {
  /* SVG file type icon */
  width: 80px;
  height: 80px;
  opacity: 0.7;
}

.send-attachment-modal-filename {
  font-family: 'roboto', sans-serif;
  max-width: 90%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.send-attachment-modal-caption {
  box-sizing: border-box;
  width: 100%;
  height: 50px;
  padding: 10px;
  resize: none;
  border: 1px solid rgba(96, 125, 139, 0.35);
  outline: none;
  border-radius: 5px;
  font-size: 14px;
  line-height: 15px;
  overflow-y: hidden;
  margin: 10px 0px;
  font-family: 'roboto', sans-serif;
}

.send-attachment-modal-send {
  box-sizing: border-box;
  padding: 0px 16px;
  margin: -8px 0px 0px;
  height: 36px;
  font-family: 'roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: white;
  text-transform: uppercase;
  background: rgb(222, 72, 88);
  border-radius: 2px;
  border: none;
  outline: none;
  cursor: pointer;
  user-select: none;
  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);
  min-width: 88px;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
  width: 100%;
}

.send-attachment-modal-close {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  height: 24px;
  width: 24px;
  cursor: pointer;
  background-color: white;
  border-radius: 50%;
}

/* Progress bar container at bottom of preview */
.send-attachment-modal-progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50px;
  background-color: color-mix(in srgb, var(--netsfere-red) 85%, transparent);
  border-radius: 0 0 5px 5px;
  overflow: hidden;
}

/* Animated fill for progress bar */
.send-attachment-modal-progress-fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background-color: rgb(222, 72, 88);
  transition: width 0.3s ease-out;
}

/* Content overlay (spinner + percentage) */
.send-attachment-modal-progress-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  z-index: 1;
}

/* Percentage text */
.send-attachment-modal-progress-text {
  color: white;
  font-size: 18px;
  font-weight: 500;
  font-family: 'roboto', sans-serif;
}

/* Spinning loader icon */
.send-attachment-modal-progress-content .material-icons.spin {
  color: white;
  font-size: 20px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/SendAttachmentModal.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,gDAAgD;EAChD,eAAe;EACf,4EAA4E;EAC5E,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,+BAA+B;EAC/B,YAAY;EACZ,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,0EAA0E;EAC1E,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".send-attachment-modal {\n  border-radius: 5px;\n  background-color: white;\n  position: relative;\n  height: 400px;\n  width: 300px;\n  padding: 3%;\n  display: flex;\n  flex-direction: column;\n  row-gap: 10px;\n}\n\n.send-attachment-modal-preview {\n  position: relative;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgba(96, 125, 139, 0.2);\n  border-radius: 5px;\n  background-color: rgba(0, 0, 0, 0.02);\n  overflow: hidden;\n}\n\n.send-attachment-modal-image {\n  max-width: 100%;\n  max-height: 90%;\n  object-fit: contain;\n}\n\n.send-attachment-modal-image.thumbnail {\n  /* Actual thumbnail from generated image/video */\n  border-radius: 3px;\n}\n\n.send-attachment-modal-image.file-icon {\n  /* SVG file type icon */\n  width: 80px;\n  height: 80px;\n  opacity: 0.7;\n}\n\n.send-attachment-modal-filename {\n  font-family: 'roboto', sans-serif;\n  max-width: 90%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.send-attachment-modal-caption {\n  box-sizing: border-box;\n  width: 100%;\n  height: 50px;\n  padding: 10px;\n  resize: none;\n  border: 1px solid rgba(96, 125, 139, 0.35);\n  outline: none;\n  border-radius: 5px;\n  font-size: 14px;\n  line-height: 15px;\n  overflow-y: hidden;\n  margin: 10px 0px;\n  font-family: 'roboto', sans-serif;\n}\n\n.send-attachment-modal-send {\n  box-sizing: border-box;\n  padding: 0px 16px;\n  margin: -8px 0px 0px;\n  height: 36px;\n  font-family: 'roboto', sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  color: white;\n  text-transform: uppercase;\n  background: rgb(222, 72, 88);\n  border-radius: 2px;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  user-select: none;\n  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);\n  min-width: 88px;\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;\n  width: 100%;\n}\n\n.send-attachment-modal-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  transform: translate(50%, -50%);\n  height: 24px;\n  width: 24px;\n  cursor: pointer;\n  background-color: white;\n  border-radius: 50%;\n}\n\n/* Progress bar container at bottom of preview */\n.send-attachment-modal-progress-bar {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 50px;\n  background-color: color-mix(in srgb, var(--netsfere-red) 85%, transparent);\n  border-radius: 0 0 5px 5px;\n  overflow: hidden;\n}\n\n/* Animated fill for progress bar */\n.send-attachment-modal-progress-fill {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  background-color: rgb(222, 72, 88);\n  transition: width 0.3s ease-out;\n}\n\n/* Content overlay (spinner + percentage) */\n.send-attachment-modal-progress-content {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  z-index: 1;\n}\n\n/* Percentage text */\n.send-attachment-modal-progress-text {\n  color: white;\n  font-size: 18px;\n  font-weight: 500;\n  font-family: 'roboto', sans-serif;\n}\n\n/* Spinning loader icon */\n.send-attachment-modal-progress-content .material-icons.spin {\n  color: white;\n  font-size: 20px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
